module.exports = __webpack_public_path__ + "static/img/buy_chance_pop_up_bg.5646b73.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buy_more/buy_chance_pop_up_bg.png
// module id = T9tg
// module chunks = 1